// material
import { alpha, styled } from '@material-ui/core/styles'
import { LinearProgress } from '@material-ui/core'
//
import Logo from './Logo'

// ----------------------------------------------------------------------

// Used as the full-screen fallback while auth initialises (App.js), as the
// Suspense fallback for lazy routes (routes/index.js) and by PersistGate, which
// renders it outside ThemeConfig, so every palette read is optional.
const RootStyle = styled('div')(({ theme }) => ({
  height: '100%',
  minHeight: 240,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2.5),
  backgroundColor: theme.palette.background?.default,
  // Stay invisible for fast loads; fade in only when the wait is noticeable.
  animation: 'genesusLoadingIn 240ms ease-out 200ms both',
  '@keyframes genesusLoadingIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
}))

const ProgressStyle = styled(LinearProgress)(({ theme }) => ({
  width: 120,
  height: 2,
  borderRadius: 2,
  backgroundColor: alpha(theme.palette.primary.main, 0.16),
  '& .MuiLinearProgress-bar': {
    borderRadius: 2,
    backgroundColor: theme.palette.primary.main,
  },
}))

// ----------------------------------------------------------------------

export default function LoadingScreen({ ...other }) {
  return (
    <RootStyle role="status" aria-live="polite" {...other}>
      <Logo mark sx={{ width: 40 }} />
      <ProgressStyle aria-label="Loading" />
    </RootStyle>
  )
}
